// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assets de las fichas que se colocan sobre la alfombra
 * @param {*} scene
 */
export function cargaAssetsFichasAlfombra(scene) {
  // ficha10
  scene.load.spritesheet(
    "fichaAlfombra10",
    ROUTES.rutaBlackJackFichasAlfombra +
      "/fichaAlfombraGrande1Resized-Sheet.png",
    {
      frameWidth: 32,
      frameHeight: 32,
    }
  );

  // ficha20
  scene.load.spritesheet(
    "fichaAlfombra20",
    ROUTES.rutaBlackJackFichasAlfombra +
      "/fichaAlfombraGrande2Resized-Sheet.png",
    {
      frameWidth: 32,
      frameHeight: 32,
    }
  );

  // ficha50
  scene.load.spritesheet(
    "fichaAlfombra50",
    ROUTES.rutaBlackJackFichasAlfombra +
      "/fichaAlfombraGrande3Resized-Sheet.png",
    {
      frameWidth: 32,
      frameHeight: 32,
    }
  );

  // ficha100
  scene.load.spritesheet(
    "fichaAlfombra100",
    ROUTES.rutaBlackJackFichasAlfombra +
      "/fichaAlfombraGrande4Resized-Sheet.png",
    {
      frameWidth: 32,
      frameHeight: 32,
    }
  );

  // fichaComodin
  scene.load.spritesheet(
    "fichaAlfombraComodin",
    ROUTES.rutaBlackJackFichasAlfombra +
      "/fichaAlfombraGrande5Resized-Sheet.png",
    {
      frameWidth: 32,
      frameHeight: 32,
    }
  );
}
